var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[(!_vm.permissionsLoaded)?_c('h3',{staticClass:"datamap-loading-component text-muted"},[_vm._v(" loading... ")]):(_vm.permissionsLoaded && _vm.hasAccess)?_c('RouterView'):_c('Forbidden')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }